'use client';

import { PropsWithChildren } from 'react';
import { SWRConfig } from 'swr';

interface Props {
  fallback: Record<string, any>;
  revalidateIfStale?: boolean;
  revalidateOnMount?: boolean;
  revalidateOnFocus?: boolean;
  revalidateOnReconnect?: boolean;
}

export default function SWRProvider({
  fallback,
  revalidateIfStale = false,
  revalidateOnMount = false,
  revalidateOnFocus = false,
  revalidateOnReconnect = false,
  children,
}: PropsWithChildren<Props>) {
  return (
    <SWRConfig
      value={{
        fallback,
        revalidateIfStale,
        revalidateOnMount,
        revalidateOnFocus,
        revalidateOnReconnect,
      }}
    >
      {children}
    </SWRConfig>
  );
}
